import { TripDto } from "src/app/proxy/dto";
import { JourneyStatus, TripStatus } from "../../proxy/enums";
import { Driver } from "./driver";
import { NurseryLocation } from "./nursery-location";
import { TransportCompany } from "./transport-company";
import { TripJourney } from "./trip-journey";
import { Truck } from "./truck";
import { AppConsts } from "../AppConsts";

export class Trip implements TripDto {
  tripNumber: string;
  isPublished: boolean;
  sendedDate?: string;
  jsonTrip?: string;
  createdDate?: string;
  transportCompany: TransportCompany;
  origin: NurseryLocation;
  destination: NurseryLocation;
  vehicle: Truck;
  driver: Driver;
  comments?: string;
  status?: TripStatus;
  journeys: TripJourney[];
  activeJourneyByReceptionOrigin: TripJourney;
  createdUserId: number;
  createdUserVId?: string;
  createdUserName?: string;
  nurseryLeavingTime?: string;
  finalKms: number;
  isSmartTrip: boolean;
  nurseryDepartureDateTime?: string;
  estimatedArrivalDateTime?: string;
  declaredEstimatedArrivalDateTime?: string;
  originLoadDateTime?: string;
  tripTypeId: number;
  declaredInitialKilometers: number;
  tripTraveledArcgisKilometers: number;

  constructor(dto: TripDto) {
    const { completedLegs, loadingTime, journeys, activeJourneyByReceptionOrigin, ...rest } = dto;
    Object.assign(this, rest);
    this.journeys = journeys?.map(j => new TripJourney(j)) || [];
  }

  get completedLegs(): string {
    if (!this.journeys || this.journeys.length === 0) return '';
    const completedCount = this.journeys.filter(j => j.status === JourneyStatus.Completed).length;
    return `${completedCount}/${this.journeys.length}`;
  }

  get loadingTime(): string {
    const validJourneys = this.journeys?.filter(j => j.loadingTime);
    if (!validJourneys?.length) return Date.now().toString();
    return this.journeys
      .slice()
      .sort((a, b) => new Date(b.loadingTime).getTime() - new Date(a.loadingTime).getTime())[0]
      .loadingTime;
  }

  setActiveJourneyByReceptionOrigin(locationId: number): void {
    if (!this.journeys?.length) {
      this.activeJourneyByReceptionOrigin = null;
      return;
    }

    const orderedJourneys = [...this.journeys].sort(
      (a, b) => AppConsts.JourneyEnumOrder[a.status] - AppConsts.JourneyEnumOrder[b.status]
    );

    this.activeJourneyByReceptionOrigin = orderedJourneys.find(j => j.destination?.locationId === locationId) || null;
  }
}

